"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Hamburger = _interopRequireDefault(require("../Hamburger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var AppBar = function AppBar(props) {
  var id = props.id,
    className = props.className,
    style = props.style,
    iconElementLeft = props.iconElementLeft,
    iconStyleLeft = props.iconStyleLeft,
    iconElementRight = props.iconElementRight,
    iconStyleRight = props.iconStyleRight,
    onHamburgerIconClick = props.onHamburgerIconClick,
    opened = props.opened;
  var appBarClass = function appBarClass() {
    return (0, _classnames["default"])({
      'ui-app-bar': true
    }, className);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: appBarClass(),
    id: id,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-app-bar__left-container"
  }, onHamburgerIconClick ? /*#__PURE__*/_react["default"].createElement(_Hamburger["default"], {
    className: "mr-two",
    opened: opened,
    onMenuClick: props.onHamburgerIconClick
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-app-bar__left",
    style: iconStyleLeft
  }, iconElementLeft)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-app-bar__right",
    style: iconStyleRight
  }, iconElementRight));
};
AppBar.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,
  /** className for reference */
  className: _propTypes["default"].string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,
  /** The custom element to be displayed on the left side of the app bar. */
  iconElementLeft: _propTypes["default"].node,
  /** Override the inline-styles of the element displayed on the left side of the app bar. */
  iconStyleLeft: _propTypes["default"].object,
  /** The custom element to be displayed on the right side of the app bar. */
  iconElementRight: _propTypes["default"].node,
  /** Override the inline-styles of the element displayed on the right side of the app bar. */
  iconStyleRight: _propTypes["default"].object,
  /** Function for when the left hamburger icon is selected via a touch tap. */
  onHamburgerIconClick: _propTypes["default"].func,
  /** If true, App Bar will recognize as opened */
  opened: _propTypes["default"].bool.isRequired
};
AppBar.defaultProps = {
  id: '',
  className: '',
  style: {},
  iconElementLeft: '',
  iconStyleLeft: {},
  iconElementRight: '',
  iconStyleRight: {},
  onHamburgerIconClick: null
};
var _default = AppBar;
exports["default"] = _default;